import React, { useMemo } from "react";
import TimeentriesCell from "./TimeentriesCell";

const DOW = ["Dum", "Lun", "Mar", "Mie", "Joi", "Vin", "Sâm"];
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

/** Zilele lucrătoare (luni–vineri) ale lunii, grupate pe săptămâni. */
export function monthWeeks(year, month) {
  const weeks = [];
  let cur = null;
  const last = new Date(year, month, 0).getDate();
  for (let day = 1; day <= last; day++) {
    const d = new Date(year, month - 1, day);
    if (d.getDay() === 0 || d.getDay() === 6) continue;
    if (!cur || d.getDay() === 1) { cur = []; weeks.push(cur); }
    cur.push({ iso: iso(d), day, dow: DOW[d.getDay()] });
  }
  return weeks;
}

const fmt = (n) => (Math.round(n * 100) / 100).toString();

export default function TimeentriesCalendar({ year, month, rows, entryIndex, validationIndex, holidays, structureNames,
                                              canValidate, closed, onSaveCell, onToggleValidation }) {
  const weeks = useMemo(() => monthWeeks(year, month), [year, month]);
  const hol = useMemo(() => new Set(holidays), [holidays]);

  return (
    <div className="card te-scroll" data-testid="te-calendar">
      <table className="te-grid">
        <thead>
          <tr>
            <th className="te-person">Nume · Marcă · Structură</th>
            {weeks.map((w, i) => (
              <React.Fragment key={i}>
                {w.map(d => <th key={d.iso} className={hol.has(d.iso) ? "te-hol" : ""}>{d.dow}<span className="te-day">{d.day}</span></th>)}
                <th className="te-wk" title="Total săptămână">Σ</th>
              </React.Fragment>
            ))}
            <th className="te-total">Total lunar</th>
            <th>Status</th>
            {canValidate && <th>Acțiuni</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map(emp => {
            const val = validationIndex[emp.id];
            const validated = !!(val && val.is_validated);
            let monthTotal = 0;
            return (
              <tr key={emp.id} data-testid={`te-row-${emp.marca}`}>
                <td className="te-person">
                  <div className="te-pname">{emp.name}</div>
                  <div className="te-psub">{emp.marca}{structureNames[emp.org_unit_id] ? ` · ${structureNames[emp.org_unit_id]}` : ""}</div>
                </td>
                {weeks.map((w, i) => {
                  let weekTotal = 0;
                  const cells = w.map(d => {
                    const entry = entryIndex[`${emp.id}|${d.iso}`];
                    if (entry) weekTotal += entry.hours;
                    if (hol.has(d.iso)) return <td key={d.iso} className="te-hol" title="Sărbătoare legală">—</td>;
                    return (
                      <td key={d.iso}>
                        <TimeentriesCell entry={entry} readOnly={validated || closed || !emp.can_edit}
                          testId={`te-cell-${emp.marca}-${d.iso}`}
                          onSave={(v) => onSaveCell(emp, d.iso, entry, v)} />
                      </td>
                    );
                  });
                  monthTotal += weekTotal;
                  return (
                    <React.Fragment key={i}>
                      {cells}
                      <td className="te-wk">{fmt(weekTotal)}</td>
                    </React.Fragment>
                  );
                })}
                <td className="te-total" data-testid={`te-total-${emp.marca}`}>{fmt(monthTotal)}</td>
                <td>
                  <span className={`badge ${validated ? "te-status-ok" : "te-status-draft"}`} data-testid={`te-status-${emp.marca}`}>
                    {validated ? "✓ Validat" : "Draft"}
                  </span>
                </td>
                {canValidate && (
                  <td>
                    <button className={`btn ${validated ? "btn-secondary" : "btn-primary"}`} style={{ padding: "3px 10px", fontSize: 12, whiteSpace: "nowrap" }}
                      disabled={closed} title={closed ? "Luna este închisă sau blocată" : undefined}
                      onClick={() => onToggleValidation(emp, validated)} data-testid={`te-validate-${emp.marca}`}>
                      {validated ? "Deblocare/Modificare" : "Validare pontaj proiect"}
                    </button>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
